import { financeChips } from '../financeHeaderCommon';

/*
 * Payroll detail config (built-in) — mirror of billingConfig.js. Auto-registered
 * under module key "payroll". Same DetailHeaderCard `variant: 'finance'` path
 * (finance header design), resolved against financeRecords
 * (recordKey:"timesheetId"). Only the status field differs (payroll.status).
 */
export const payrollConfig = {
  module: 'payroll',
  tabs: [],
  header: {
    variant: 'finance',
    title: 'candidateName',
    eyebrow: 'designation',
    statusField: 'payroll.status',
    chips: financeChips,
  },
};

export default payrollConfig;
